import LocalizedStrings from 'react-localization';
import {combineLocale} from './combineLocale';
import {common} from './common';
import {home} from './home';
import {login} from './login';
import {customer} from './customer';
import {pagination} from './pagination';
import {dashboard} from './dashboard';
import {property} from './property';
import {site} from './site';
import {user} from './user';
import {header} from './header';
import {sidebar} from './sidebar';
import {GISView} from './GISView';
import {email} from './email';
import {SMS} from './SMS';
import {device} from './device';
import {consumption} from './consumption';
import {forgotpassword} from './forgotpassword';
import {resetpassword} from './resetpassword';
import {state} from './state';
import {city} from './city';
import {pincode} from './pincode';
import {role} from './role';
import {location} from './location';
import {consumer} from './consumer';
import {zone} from './zone';
import {address} from './address';
import {batteryHealth} from './batteryHealth';
import {DrsFile} from './DrsFile';
import {report} from './report';
import {log} from './log';
import {settings} from './settings';
import {hierarchy} from './hierarchy';
import {tamper} from './tamper';
import {alertConfig} from './alertConfig';
import {productType} from './productType';
import {product} from './product';
import {project} from './project';
import {pole} from './pole';
import {lamp} from './lamp';
import {ledLoad} from './ledLoad';
import {feeder} from './feeder';
import {calendar} from './calendar';
import { firmware } from './firmware';


/**
* Gets the programmatic name of the entire locale, with the language,
*   country and variant separated by underbars. The Language is always lower case,
*   and country is always upper case. If the language is missing,
*   the string will begin with an underscore character.
*   If both the language and country fields are missing,
*   this function will return the empty string,
*   even if the variant field is filled in (you cannot have a locale with just a variant--
*   the variant must accompany a valid language or country code). Examples: "en"
*
*/
export const avaliableLanguages = {en: 'English',ar:'Arabic'}
export const locale = new LocalizedStrings(
     /*Handling events with React elements is very similar to handling events on DOM elements
    * Inside a loop it is common to want to pass an extra parameter to an event handler.
    *the e argument representing the React event will be passed as a second argument after the ID.
    *With an arrow function, we have to pass it explicitly,
    *but with bind any further arguments are automatically forwarded
    *The bind() method creates a new function that, when called, has its this keyword set to the provided value
    *An arrow function expression has a shorter syntax than a function expression and does not have its own this, arguments, super, or new.target
    */
    combineLocale({
        common: common,
        home: home,
        login: login,
        customer: customer,
        productType:productType,
        pagination: pagination,
        dashboard:dashboard,
        product:product,
        project:project,
        property:property,
        site:site,
        user:user,
        header:header,
        sidebar:sidebar,
        settings:settings,
        GISView:GISView,
        SMS:SMS,
        email:email,
        device:device,
        consumption:consumption,
        forgotpassword:forgotpassword,
        resetpassword:resetpassword,
        role:role,
        location:location,
        consumer:consumer,
        zone:zone,
        DrsFile:DrsFile,
        batteryHealth:batteryHealth,
        address:address,
        report:report,
        log:log,
        state:state,
        city:city,
        pincode:pincode,
        hierarchy:hierarchy,
        tamper:tamper,
        alertConfig:alertConfig,
        lamp:lamp,
        pole:pole,
        ledLoad:ledLoad,
        feeder:feeder,
        calendar:calendar,
        firmware
    })
);

if (!localStorage.getItem('language')) {
    const navigatorLanguage = (navigator.language).slice(0,2);
    const preSelectedLanguage = navigatorLanguage === 'ar' ? 'ar' : 'en';
    
    localStorage.setItem("language",preSelectedLanguage)
}

if ((typeof localStorage.getItem('language') === 'string')) {
    locale.setLanguage(localStorage.getItem('language'));
}


export const onChangeLanguage = (e,{value}) => {
    const currentLanguage = localStorage.getItem('language');
    if (currentLanguage !== value) {
    localStorage.setItem("language",value)
    window.location.reload()
    }
}